import { jsx } from "@builder.io/qwik/jsx-runtime";
import { component$, useContext, useSignal, $, sync$, useTask$, Slot } from "@builder.io/qwik";
import { TooltipContextId } from "./tooltip-context.qwik.mjs";
import { isServer } from "@builder.io/qwik/build";
import { usePopover } from "../popover/use-popover.qwik.mjs";
const HTooltipTrigger = component$((props) => {
  const context = useContext(TooltipContextId);
  const openTimeout = useSignal();
  const closeTimeout = useSignal();
  const { showPopover, hidePopover } = usePopover(context.localId);
  const clearTimeoutIfExists = $((timeoutRef) => {
    if (timeoutRef.value) {
      window.clearTimeout(timeoutRef.value);
      timeoutRef.value = void 0;
    }
  });
  const setTooltipState = $((open, state, timeoutRef) => {
    context.state.value = state;
    if (context.delayDuration > 0) {
      timeoutRef.value = window.setTimeout(() => {
        context.state.value = open ? "open" : "closed";
      }, context.delayDuration);
    } else {
      context.state.value = open ? "open" : "closed";
    }
  });
  const setTooltipOpen$ = $(() => {
    clearTimeoutIfExists(closeTimeout);
    showPopover();
    setTooltipState(true, "opening", openTimeout);
  });
  const setTooltipClosed$ = $(() => {
    clearTimeoutIfExists(openTimeout);
    hidePopover();
    setTooltipState(false, "closing", closeTimeout);
  });
  const preventDefaultSync$ = sync$((e) => {
    e.preventDefault();
  });
  const handleKeyDown$ = $(async (e) => {
    if (context.state.value === "open" && e.key === "Escape") {
      e.preventDefault();
      setTooltipClosed$();
    }
  });
  useTask$(({ track, cleanup }) => {
    track(() => context.state.value);
    if (isServer)
      return;
    if (context.state.value === "open") {
      document.addEventListener("keydown", handleKeyDown$);
      cleanup(() => {
        document.removeEventListener("keydown", handleKeyDown$);
      });
    } else if (context.state.value === "closed") {
      document.removeEventListener("keydown", handleKeyDown$);
    }
    cleanup(() => {
      document.removeEventListener("keydown", handleKeyDown$);
    });
  });
  return /* @__PURE__ */ jsx("button", {
    ref: context.triggerRef,
    onMouseOver$: [
      preventDefaultSync$,
      setTooltipOpen$
    ],
    onMouseLeave$: setTooltipClosed$,
    onFocus$: setTooltipOpen$,
    onBlur$: setTooltipClosed$,
    onKeyDown$: handleKeyDown$,
    "aria-describedby": context.localId,
    "data-state": context.state.value,
    ...props,
    children: /* @__PURE__ */ jsx(Slot, {})
  });
});
export {
  HTooltipTrigger
};
